import React from "react";
import { useTheme } from "styled-components";

import { ReactComponent as LogoLight } from "../img/logo/LogoLight.svg";
import { ReactComponent as LogoDark } from "../img/logo/LogoDark.svg";

/**
 * BrandLogo
 * - **auto** (default): light logo in dark mode, dark logo in light mode
 * - **light**: force light (white) logo
 * - **dark**: force dark (brand blue) logo
 */
export default function BrandLogo({
  variant = "auto",
  className = "",
  title = "Core Arena",
  ...props
}) {
  const theme = useTheme();
  const mode = theme?.mode || "light";

  const resolved =
    variant === "auto" ? (mode === "dark" ? "light" : "dark") : variant;

  const classes = `${className ? className + " " : ""}brand-logo`.trim();

  if (resolved === "light") {
    return <LogoLight className={classes} role="img" aria-label={title} {...props} />;
  }
  return <LogoDark className={classes} role="img" aria-label={title} {...props} />;
}

